// Phase 6 — Track B T-B5. Alerts copy.
//
// Priority labels match the §14.4 scale — `info`, `noteworthy`, `important`,
// `critical`. Backend currently models three priorities (info / important /
// critical); the `noteworthy` slot is reserved for v2.x and rendered only
// when the backend surfaces it.

export const alertsCopy = {
  navLabel: 'Alerts',
  pageTitle: 'Alerts',
  pageSubtitle: 'Recent attention items across your modules.',
  bellLabel: 'Open alerts',
  filters: {
    all: 'All',
    critical: 'Critical',
    important: 'Important',
    info: 'Info',
  },
  priorities: {
    info: 'Info',
    noteworthy: 'Noteworthy',
    important: 'Important',
    critical: 'Critical',
  },
  emptyTitle: 'You are all caught up',
  emptyBody: 'No alerts in your recent feed.',
  loadingLabel: 'Loading alerts',
  errorTitle: 'Could not load alerts',
  errorBody: 'Try again in a moment.',
  retry: 'Retry',
} as const;
